import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Representa un producto que puede ser editado en una compra con crédito fiscal.
 */
export interface TaxCreditProductForEdit {
  id: number;              // ID del detalle del producto
  productId: number;       // ID del producto
  productName: string;     // Nombre del producto
  quantity: number;        // Cantidad
  unitCost: number;        // Costo unitario
  ivaTotal: number;        // IVA total
  totalCost: number;       // Costo total
  taxType: 'TAXED' | 'EXEMPT'; // Tipo de impuesto
}

/**
 * Estado global para compras con crédito fiscal.
 */
interface TaxCreditPurchaseState {
  productToEdit: TaxCreditProductForEdit | null;
  showAddProductModal: boolean;
  showEditProductModal: boolean;
}

const initialState: TaxCreditPurchaseState = {
  productToEdit: null,
  showAddProductModal: false,
  showEditProductModal: false,
};

const taxCreditPurchaseSlice = createSlice({
  name: 'taxCreditPurchase',
  initialState,
  reducers: {
    /**
     * Establece el producto que se desea editar.
     */
    setProductToEdit(state, action: PayloadAction<TaxCreditProductForEdit>) {
      state.productToEdit = action.payload;
    },

    /**
     * Limpia el producto seleccionado para edición.
     */
    clearProductToEdit(state) {
      state.productToEdit = null;
    },

    /**
     * Abre el modal para agregar un nuevo producto.
     */
    openAddProductModal(state) {
      state.showAddProductModal = true;
    },

    /**
     * Cierra el modal de agregar producto.
     */
    closeAddProductModal(state) {
      state.showAddProductModal = false;
    },

    /**
     * Abre el modal de edición de producto.
     */
    openEditProductModal(state) {
      state.showEditProductModal = true;
    },

    /**
     * Cierra el modal de edición de producto.
     */
    closeEditProductModal(state) {
      state.showEditProductModal = false;
    },
  },
});

export const {
  setProductToEdit,
  clearProductToEdit,
  openAddProductModal,
  closeAddProductModal,
  openEditProductModal,
  closeEditProductModal,
} = taxCreditPurchaseSlice.actions;

export default taxCreditPurchaseSlice.reducer;
